module.exports = __webpack_public_path__ + "static/media/image-search.2095f9bd.jpg";